import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { CoreModule } from './modules/core/core.module';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './modules/core/interceptors/token.interceptor';
import { ErrorInterceptor } from './modules/core/interceptors/error.interceptor';
import { AuthService } from './modules/core/services/auth.service';
import { AuthGuard } from './modules/core/guards/auth.guard';
import { RoleGuard } from './modules/core/guards/role.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSonnerToaster } from 'ngx-sonner'
import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSonnerToaster,
    FullCalendarModule,
    RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'top' })
  ],
  providers: [
    AuthService,
    AuthGuard,
    RoleGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
